module.exports = __webpack_public_path__ + "static/media/IMG_6420.ce00dd6f.jpg";